import * as React from "react";
const SvgLoader = (props) => /* @__PURE__ */ React.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", width: "100%", height: "100%", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props }, /* @__PURE__ */ React.createElement("circle", { className: "path", cx: 25, cy: 25, r: "2rem", fill: "none" }));
export default SvgLoader;
